import { css } from '@emotion/react'
import styled from '@emotion/styled'

export const ButtonsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 12px;
`

export const button = css`
  margin-left: 8px;
`
